<template>
    <div class="content">
        <h2>现场笔录</h2>
        
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <div v-show="sc">
            <el-row>
                    <el-col :span="24">
                        <el-form-item label="编号:" prop="bh">
                            <el-input style="width:200px; margin-right:10px;"
                            v-model="form.bh" disabled
                            placeholder="请输入"
                            clearable
                            size="small"
                            />
                            <el-button type="warning" size="small" @click="getWh(1)">获取编号</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="时间:"  required>
                            <el-form-item prop="xwrq" style="width:230px; float:left;">
                                <el-date-picker size="small"
                                    v-model="form.xwrq"
                                    type="date"
                                    placeholder="选择日期" value-format="yyyy-MM-dd">
                                </el-date-picker>&nbsp;
                            </el-form-item>
                            <el-form-item prop="startTime" style="width:145px; float:left;">
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="起始时间"  format="HH:mm"
                                    value-format="HH:mm"
                                v-model="form.startTime">
                            </el-time-picker>&nbsp;至&nbsp;
                        </el-form-item>
                            <el-form-item prop="endTime" style="width:120px; float:left;">
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="结束时间" format="HH:mm"
                                    value-format="HH:mm"
                                v-model="form.endTime">
                            </el-time-picker>
                            </el-form-item>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="陪同人:" prop="ptr">
                            <el-input
                            v-model="form.ptr"
                            placeholder="请输入陪同人"
                            clearable
                            size="small" @input="getTet(1)" style="width:200px;"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="笔录状态:" prop="blzt">
                            <el-radio-group v-model="form.blzt" @change="getBl">
                                <el-radio label='1'>首次</el-radio>
                                <el-radio label='2'>复查</el-radio>
                                <el-radio label='3'>无复查</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="检查内容:" prop="jcnr">
                            <el-input type="textarea" rows="7"
                            v-model="form.jcnr"
                            placeholder="请输入检查内容"
                            clearable
                            size="small"
                            />
                            <el-button type="warning" size="small" @click="getNr(1)">检查内容</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="签名方式:" prop="qmfs">
                            <el-radio-group v-model="form.qmfs">
                                <el-radio :label="1">电子签名及日期</el-radio>
                                <el-radio :label="2">手工签名无日期</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0" style="text-align:center;">
                            <el-button type="primary" @click="submit('form')">生成现场笔录</el-button>
                            <el-button type="warning" v-if="isWs" @click="show(1)">预览</el-button>
                            <el-button type="danger" v-if="isWs" @click="edit(1)">编辑</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>    
            <div v-show="!sc">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="编号:" prop="fc_bh">
                            <el-input style="width:200px; margin-right:10px;"
                            v-model="form.fc_bh" disabled
                            placeholder="请输入"
                            clearable
                            size="small"
                            />
                            <el-button type="warning" size="small" @click="getWh(2)">获取编号</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="时间:"  required>
                            <el-form-item prop="fc_xwrq" style="width:230px; float:left;">
                                <el-date-picker size="small"
                                    v-model="form.fc_xwrq"
                                    type="date"
                                    placeholder="选择日期" value-format="yyyy-MM-dd">
                                </el-date-picker>&nbsp;
                            </el-form-item>
                            <el-form-item prop="fc_startTime" style="width:145px; float:left;">
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="起始时间"  format="HH:mm"
                                    value-format="HH:mm"
                                v-model="form.fc_startTime">
                            </el-time-picker>&nbsp;至&nbsp;
                        </el-form-item>
                            <el-form-item prop="fc_endTime" style="width:120px; float:left;">
                            <el-time-picker size="small" style="width:120px;"
                                placeholder="结束时间" format="HH:mm"
                                    value-format="HH:mm"
                                v-model="form.fc_endTime">
                            </el-time-picker>
                            </el-form-item>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="陪同人:" prop="fc_ptr">
                            <el-input
                            v-model="form.fc_ptr"
                            placeholder="请输入陪同人"
                            clearable
                            size="small" @input="getTet(2)" style="width:200px;"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="笔录状态:" prop="blzt">
                            <el-radio-group v-model="form.blzt" @change="getBl">
                                <el-radio label='1'>首次</el-radio>
                                <el-radio label='2'>复查</el-radio>
                                <el-radio label='3'>无复查</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="检查内容:" prop="fc_jcnr">
                            <el-input type="textarea" rows="7"
                            v-model="form.fc_jcnr"
                            placeholder="请输入检查内容"
                            clearable
                            size="small"
                            />
                            <el-button type="warning" size="small" @click="getNr(2)">检查内容</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="签名方式:" prop="qmfs">
                            <el-radio-group v-model="form.qmfs">
                                <el-radio :label="1">电子签名及日期</el-radio>
                                <el-radio :label="2">手工签名无日期</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0" style="text-align:center;">
                            <el-button type="primary" @click="submit('form')">生成现场笔录</el-button>
                            <el-button type="warning" v-if="isWs2" @click="show(2)">预览</el-button>
                            <el-button type="danger" v-if="isWs2" @click="edit(2)">编辑</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            
        </el-form>
        <el-dialog title="检查内容" :visible.sync="open" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-row :gutter="40">
                    <el-col :span="7">
                        <ul class="zfmb" style="max-height:500px;overflow-y: auto;">
                            <li v-for="(item,index) in zfmbList" :key="index">
                            <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                            <div v-show="isActive == index" class="zfmb2">
                                <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">{{itema.mcjianxie}}</span>
                            </div>
                            </li>
                        </ul>
                    </el-col>
                    <el-col :span="17">
                        <el-form ref="form2" :model="form2">
                            <!-- <el-form-item label="" prop="wfss">
                                <el-checkbox v-model="form2.wfss" @change="getXz">违法事实</el-checkbox>
                            </el-form-item> -->
                            <el-form-item label="" prop="jcnr">
                                <el-input type="textarea" rows="8" v-model="form2.jcnr" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="onSubmit('form2')">确定</el-button>
                    <el-button  size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="现场笔录" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    props:['code','pcId','hysj','jdy1','jdy2','dwmc'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
                blzt:'2',
                qmfs:1,
                jcnr:'',
                ptr:'',
            },
            rules:{
                bh:[
                    { required: true, message: '现场笔录编号不能为空', trigger: 'blur' }
                ],
                xwrq:[
                    { required: true, message: '询问日期不能为空', trigger: ['change','blur'] }
                ],
                startTime:[
                    { required: true, message: '开始时间不能为空', trigger: ['change','blur'] }
                ],
                endTime:[
                    { required: true, message: '结束时间不能为空', trigger: ['change','blur'] }
                ],
                blzt:[
                    { required: true, message: '笔录状态不能为空', trigger: ['change','blur'] }
                ],
                jcnr:[
                    { required: true, message: '检查内容不能为空', trigger: 'blur' }
                ],
                qmfs:[
                    { required: true, message: '签名方式不能为空', trigger: 'blur' }
                ],
                fc_bh:[
                    { required: true, message: '现场笔录编号不能为空', trigger: 'blur' }
                ],
                fc_xwrq:[
                    { required: true, message: '询问日期不能为空', trigger: ['change','blur'] }
                ],
                fc_startTime:[
                    { required: true, message: '开始时间不能为空', trigger: ['change','blur'] }
                ],
                fc_endTime:[
                    { required: true, message: '结束时间不能为空', trigger: ['change','blur'] }
                ],
                fc_jcnr:[
                    { required: true, message: '检查内容不能为空', trigger: 'blur' }
                ],
            },
            open:false,
            form2:{
                jcnr:''
            },
            wsUrl:'',
            isWs:false,
            isWs2:false,
            jdyOptions:[],
            jdyZfz1:'',
            jdyZfz2:'',
            org:'',
            zfmbList:[],
            isActive:'-1',
            isActive2:'-1',
            zfXX:[],
            titleWord:'',
            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            wsUrl2:'',
            wsPdf2:'',
            docurl2:'',
            zfXX2:[],
            text:'',
            scBl:{},
            sc:false,
            dqZt:2,
            dqText:'',
            jianchaneirong:'',
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    async created() {
  
        this.form = {
                blzt:'2',
                qmfs:1,
                jcnr:'',
                ptr:'',
            }
        this.$forceUpdate()
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        this.org = data.data[0].jcjg
         
        let dm1,dm2;
        if(this.jdy1 || this.jdy2){
            let jdy1 = this.jdy1 || ''
            let jdy2 = this.jdy2 || ''
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid
                }
            })
            .then(response => {
                let arrD = response.data.data
                arrD.forEach(item => {
                    if(item.xm === jdy1){
                        dm1 = item.dm
                        this.jdyZfz1 = item.zfzh
                    }
                    if(item.xm === jdy2){
                        dm2 = item.dm
                        this.jdyZfz2 = item.zfzh
                    }
                })
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
        }
        this.$nextTick(()=> {
            setTimeout(() => {
                let tet = this.org+'行政执法人员'+this.jdy1+'、'+this.jdy2+'着装出示浙江省行政执法证(证号依次分为:'+this.jdyZfz1+'、'+this.jdyZfz2+')，在'+this.form.ptr+'的陪同下依法进行检查，检查情况记录如下:\n'
                console.log(tet)
                this.jianchaneirong = tet
                this.getList()
            },300)
        })
    },
    async mounted() {
    },
    methods: {


        getTet(val){
            if(this.form.blzt == '1'){
                let arr = this.form.jcnr.split('，在')
                let arr2 = arr[1].split('的陪同下')
                console.log(arr,arr2)
                let text = arr[0]+'，在'+this.form.ptr+'的陪同下'+arr2[1]
                this.$set(this.form,'jcnr',text)
            }else{
                let arr = this.form.fc_jcnr.split('，在')
                let arr2 = arr[1].split('的陪同下')
                console.log(arr,arr2)
                let text = arr[0]+'，在'+this.form.fc_ptr+'的陪同下'+arr2[1]
                this.$set(this.form,'fc_jcnr',text)
            }
        },
        async getList(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = ''
                this.docurl = ''
                this.wsPdf = ''
                if(data.data[0].bilu_status){
                    if(data.data[0].bilu_status=='首次'){
                        this.sc = true
                        this.$set(this.form,'blzt','1')
                    }else if(data.data[0].bilu_status=='复查'){
                        this.sc = false
                        this.$set(this.form,'blzt','2') 
                    }else if(data.data[0].bilu_status=='无复查'){
                        this.sc = true
                        this.$set(this.form,'blzt','3') 
                    } 
                    if(data.data[0].xcbl_bh){
                        this.isWs = true
                        this.showSc(data.data[0])
                        let nm = 'xianchangbilu'
                        this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw='+nm+'&sjs='+new Date().getTime()
                        this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                        this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()        
                    }
                    if(data.data[0].xcbl_bh_fc){
                        this.isWs2 = true
                        this.showFc(data.data[0])
                        let nm = 'xianchangbilu_fc'
                        this.wsUrl2 = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw='+nm+'&sjs='+new Date().getTime()
                        this.docurl2 = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                        this.wsPdf2 = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                    } 
                    console.log(this.form)            
                }else{
                    this.isWs = false
                    this.sc = false
                    this.showFc()
                }
                //判断文书是否存在
                // let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('现场笔录')}&xcblFlag=${escape(data.data[0].bilu_status)}`)
                // if(data2.data){
                //     if(data2.data == '-1'){
                //         this.isWs = false
                //     }else{
                //         //有
                //         this.isWs = true
                //     }
                // }
            }
            
        },
        showSc(data){
            if(data){
                let bh2 = data.xcbl_bh
                console.log(bh2)
                bh2 = bh2.padStart(6,'0')
                let bh = data.lsh.slice(0,4) + '-' + bh2
                console.log(bh)
                this.$set(this.form,'bh',bh)
                let sj = data.bl_date
                this.$set(this.form,'xwrq',sj)
                let sj1 = data.bl_sj1
                this.$set(this.form,'startTime',sj1)
                let sj2 = data.bl_sj2
                this.$set(this.form,'endTime',sj2)
                let ptr = data.bl_xwr
                this.$set(this.form,'ptr',ptr)
                let nr = data.bl_nr 
                console.log(nr)
                if(nr){
                    if(nr.indexOf('检查情况记录如下：') != -1 || nr.indexOf('检查情况记录如下:') != -1){
                        this.$set(this.form,'jcnr',nr)
                    }else{
                        if(data.isnoxcbl == 0 && data.bl_lsh){
                            this.getScBl()
                        }else{
                            this.$set(this.form,'jcnr',this.jianchaneirong + nr)
                        }
                    }
                }else{
                    this.$set(this.form,'jcnr',this.jianchaneirong)
                }
                console.log(this.form)
            }else{
                let bh = new Date().getFullYear() + '-'
                this.$set(this.form,'bh',bh)
                let date = new Date()
                let sj = this.getDate(date,'hh:mm')
                let sj1 = this.getDate(date,'yyyy-MM-dd')
                this.$set(this.form,'xwrq',sj1)
                this.$set(this.form,'startTime',sj)
                let sj2 = new Date(date.getTime() + 10 * 60 * 1000);
                let sj3 = this.getDate(sj2,'hh:mm')
                this.$set(this.form,'endTime',sj3)
                this.$set(this.form,'jcnr',this.jianchaneirong)
            }
        },
        showFc(data){
            if(data){
                let bh2 = data.xcbl_bh_fc
                console.log(bh2)
                bh2 = bh2.padStart(6,'0')
                let bh = data.lsh.slice(0,4) + '-' + bh2
                console.log(bh)
                this.$set(this.form,'fc_bh',bh)
                console.log(this.form.blzt)
                let sj = data.bl_fc_date
                this.$set(this.form,'fc_xwrq',sj)
                let sj1 = data.bl_fc_sj1
                this.$set(this.form,'fc_startTime',sj1)
                let sj2 = data.bl_fc_sj2
                this.$set(this.form,'fc_endTime',sj2)
                let ptr = data.bl_fc_xwr
                this.$set(this.form,'fc_ptr',ptr)
                let nr = data.bl_fc_nr
                console.log(nr)
                if(nr){
                    if(nr.indexOf('检查情况记录如下：') != -1 || nr.indexOf('检查情况记录如下:') != -1){
                        this.$set(this.form,'fc_jcnr',nr)
                    }else{
                        this.$set(this.form,'fc_jcnr',this.jianchaneirong + nr)
                    }
                }else{
                    this.$set(this.form,'fc_jcnr',this.jianchaneirong)
                }
            }else{
                this.$set(this.form,'blzt','2')
                let bh = new Date().getFullYear() + '-'
                this.$set(this.form,'fc_bh',bh)
                let date = new Date()
                let sj = this.getDate(date,'hh:mm')
                let sj1 = this.getDate(date,'yyyy-MM-dd')
                this.$set(this.form,'fc_xwrq',sj1)
                this.$set(this.form,'fc_startTime',sj)
                let sj2 = new Date(date.getTime() + 10 * 60 * 1000);
                let sj3 = this.getDate(sj2,'hh:mm')
                this.$set(this.form,'fc_endTime',sj3)
                this.$set(this.form,'fc_jcnr',this.jianchaneirong)
            }
            
        },
        async getScBl(val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(this.dwmc)}&dwmc2=&mid=${this.zfXX[0].dwmc_id}&type=shouji`)
            console.log(data)
            if(data.data && data.data[0].bl_nr){
                let arr = data.data
                
                arr.forEach(item => {
                    if(item.lsh == this.zfXX[0].bl_lsh){
                        // this.$set(this.form,'jcnr','')
                        this.getText2(item.jdy1,item.jdy2,item.bl_xwr,item.bl_nr)
                        // this.$set(this.form,'xwrq',item.bl_date)
                        // this.$set(this.form,'startTime',item.bl_sj1)
                        // this.$set(this.form,'endTime',item.bl_sj2)
                        // this.$set(this.form,'bh',item.xcbl_bh)
                        // this.$set(this.form,'ptr',item.bl_xwr)
                    }
                })

                // if(val == 2){
                //     this.$nextTick(()=>{
                //         setTimeout(()=>{this.submit('form')},500)
                        
                //     })
                // }
                
            }
        },
        getText2(jdy1,jdy2,ptr,nr){ 
            console.log(jdy1,jdy2,ptr,nr,343)
            let jdyZfz1,jdyZfz2;
            let dm1,dm2;
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/xx/lawEnforcer`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    cmid:this.cmid
                }
            })
            .then(response => {
                let arrD = response.data.data
                arrD.forEach(item => {
                    if(item.xm === this.jdy1){
                        dm1 = item.dm
                        jdyZfz1 = item.zfzh
                    }
                    if(item.xm === this.jdy2){
                        dm2 = item.dm
                        jdyZfz2 = item.zfzh
                    }
                })
            })
            .catch(error => {
                this.$message.error('获取监督员数据失败！');
                console.error('There was an error!', error);
            });
            let nr2 = nr?nr:''
            let tet = this.org+'行政执法人员'+jdy1+'、'+jdy2+'着装出示浙江省行政执法证(证号依次分为:'+jdyZfz1+'、'+jdyZfz2+')，在'+ptr+'的陪同下依法进行检查，检查情况记录如下:\n'+nr2
            console.log(tet)
            this.$set(this.form,'jcnr',tet)
            console.log(this.form.jcnr)
        },
        async getBl(){
            if(this.form.blzt == '1' || this.form.blzt == '3'){
                this.sc = true
                if(!this.form.bh){
                    this.showSc()
                }
            }else{
                this.sc = false
                if(!this.form.fc_bh){
                    this.showFc()
                }
            }
        },
        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form2.jcnr.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.form2.jcnr){
              let zf = this.form2.jcnr.substr(this.form2.jcnr.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.form2.jcnr =  this.form2.jcnr + nr
            }else{
              this.form2.jcnr = itema.mc
            }
          }
        },
        // async getJdr1(){
        //     let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdr1&c_mid=${this.cmid}`)
        //     console.log(data)
        //     if(data.data){

        //     }
        // },
        // async getWjw(){
        //     let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdyByWjw`)
        //     console.log(data)
        //     if(data.data){

        //     }
        // },
        submit(form){
         
            let nr = ''///2024-06-15|07:00|08:30|2024-83669|123|2|wqe|undefined|1
            console.log(this.form)
            let zfzxj = ''//新旧执法证
            if(this.form.bh.replace(/2024-/g, '').length==0 || this.form.fc_bh.replace(/2024-/g, '').length==0){
                this.$message.error('请点击按钮获取编号')
                return false
            }
            if(this.form.blzt == '1' || this.form.blzt == '3'){
                let jcnr = ''
                if(this.form.jcnr.indexOf('检查情况记录如下:\n') > 0){
                    jcnr = this.form.jcnr.split('检查情况记录如下:\n')[1]
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.jcnr.indexOf('检查情况记录如下：\n') > 0){
                    jcnr = this.form.jcnr.split('检查情况记录如下：\n')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.jcnr.indexOf('检查情况记录如下:') > 0){
                    jcnr = this.form.jcnr.split('检查情况记录如下:')[1]
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.jcnr.indexOf('检查情况记录如下：') > 0){
                    jcnr = this.form.jcnr.split('检查情况记录如下：')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else{
                    jcnr = this.form.jcnr
                }
                console.log(jcnr)
                nr = this.getDate(this.form.xwrq,'yyyy-MM-dd') + '|' + this.form.startTime + '|' + this.form.endTime + '|' + escape(this.form.bh) + '|' + escape(this.form.ptr) + '|' + escape(this.form.blzt) + '|' + escape(jcnr) + '|' + escape(zfzxj) + '|' + escape(this.form.qmfs)
                
            }else{
                let jcnr = ''
                console.log(this.form.fc_jcnr)
                if(this.form.fc_jcnr.indexOf('检查情况记录如下:\n') > 0){
                    jcnr = this.form.fc_jcnr.split('检查情况记录如下:\n')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.fc_jcnr.indexOf('检查情况记录如下：\n') > 0){
                    jcnr = this.form.fc_jcnr.split('检查情况记录如下：\n')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.fc_jcnr.indexOf('检查情况记录如下:') > 0){
                    jcnr = this.form.fc_jcnr.split('检查情况记录如下:')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else if(this.form.fc_jcnr.indexOf('检查情况记录如下：') > 0){
                    jcnr = this.form.fc_jcnr.split('检查情况记录如下：')[1]
                    console.log(jcnr)
                    //jcnr = jcnr.replace(/\n/g,('\n'+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')));
                }else{
                    jcnr = this.form.fc_jcnr
                }
                console.log(jcnr)
                nr = this.getDate(this.form.fc_xwrq,'yyyy-MM-dd') + '|' + this.form.fc_startTime + '|' + this.form.fc_endTime + '|' + escape(this.form.fc_bh) + '|' + escape(this.form.fc_ptr) + '|' + escape(this.form.blzt) + '|' + escape(jcnr) + '|' + escape(zfzxj) + '|' + escape(this.form.qmfs)
                
            }
            
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let that = this
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('现场笔录'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:'',
                            // c_mid:`${this.cmid}`,
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            if (res.data.code == '') {
                                this.isFsqm = true
                            } else {
                                this.isFsqm = false
                            }
                            if(this.sc){
                                this.wsUrl = res.data.data.split('?')[1]
                            }else{
                                this.wsUrl2 = res.data.data.split('?')[1]
                            }
                            
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        async getWh(val){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblBh&id=${this.pcId}`)
            console.log(data)
            if(data.data){
                if(data.data.errMessage){
                    if(this.sc){
                        this.$set(this.form,'bh',data.data.errMessage)
                    }else{
                        this.$set(this.form,'fc_bh',data.data.errMessage)
                    }
                }else{
                    let bh = new Date().getFullYear() + '-'
                    if(this.sc){
                        this.$set(this.form,'bh',bh)
                    }else{
                        this.$set(this.form,'fc_bh',bh)
                    }
                }
            }
        },
        async getNr(val){
            this.dqZt = val
            this.dqText = val == 2 ? this.form.fc_jcnr : this.form.jcnr
            this.open = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getxcMb`)
            console.log(data)
            this.zfmbList = []
            if(data.data){
                this.zfmbList = data.data
            }
        },
        getXz(){
            console.log(this.form2.wfss)
        },
        onSubmit(){
            this.open = false
            if(this.dqZt == 2){
                this.$set(this.form,'fc_jcnr',this.dqText+this.form2.jcnr)
            }else{
               this.$set(this.form,'jcnr',this.dqText+this.form2.jcnr) 
            }
        },
        cancel(){
            this.form2 = {}
            this.open = false
        },
        show(){
            // console.log(this.wsUrl,this.wsUrl2)
            if(this.wsUrl || this.wsUrl2){
                let ws = this.form.blzt == '2' ? this.wsUrl2 : this.wsUrl
                console.log(ws)
                if(ws){
                    let mid = ws.split('&')[0].replace('mid=','')
                    let lsh = ws.split('&')[1].replace('lsh=','')
                    let wsname = ws.split('&')[2].replace('wsnameEw=','')
                    let sjs = ws.split('&')[3].replace('sjs=','')
                    let url = this.$router.resolve({
                        path:'/pdf',
                        query:{
                            mid:mid,
                            lsh:lsh,
                            wsname:wsname,
                            sjs:sjs
                        }
                    })
                    window.open(url.href,'_blank')
                }else{
                    this.$message.error('暂未制作本文书，不能预览！') 
                }
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl || this.docurl2){
                if(this.sc){
                    let url = this.docurl
                    console.log(url,1)
                    POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
                }else{
                    let url = this.docurl2
                    console.log(url,2)
                    POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
                }
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf || this.wsPdf2){
                let url = ''
                if(this.sc){
                    url = this.wsPdf
                }else{
                    url = this.wsPdf2
                }
                window.open(url,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            //let wsname = this.zfXX[0].bilu_status=='复查'
            let wsname = this.sc ? 'xianchangbilu.docx':'xianchangbilu_fc.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    if(this.sc){
                        this.wsPdf = data.data.pdfUrl
                    }else{
                        this.wsPdf2 = data.data.pdfUrl
                    }
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
.content >>> .el-textarea.is-disabled .el-textarea__inner ,.content >>> .el-input.is-disabled .el-input__inner{ color: #333;}
</style>